var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgM4Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#0B759D",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.54256 5.72063H9.13172L9.13035 3.43708C9.13035 3.19589 8.93345 3 8.69123 3C8.50658 3 8.34885 3.11447 8.28412 3.27561H6.40297C6.35153 3.27561 6.30418 3.3049 6.28101 3.35089C6.25785 3.39688 6.26296 3.45208 6.29362 3.49329L6.77771 4.14057L6.29362 4.78784C6.26262 4.82907 6.25785 4.88426 6.28101 4.93024C6.30418 4.97623 6.35119 5.00553 6.40297 5.00553H8.25107L8.25039 5.72026H7.49785C7.42256 5.72026 7.36158 5.78124 7.36158 5.85652V6.88265H5.99855C5.92326 6.88265 5.86228 6.94363 5.86228 7.01892V8.16802H4.49925C4.42397 8.16802 4.36299 8.229 4.36299 8.30429V9.34368H3.13627C3.06098 9.34368 3 9.40466 3 9.47995V10.7674C3 10.8427 3.06098 10.9036 3.13627 10.9036H9.54222C9.61751 10.9036 9.67849 10.8427 9.67849 10.7674L9.67883 5.85692C9.67883 5.78163 9.61785 5.72063 9.54256 5.72063ZM6.67513 4.73339L7.05736 4.22238C7.09347 4.17401 7.09347 4.10758 7.05736 4.0592L6.67513 3.54819H8.25244L8.25176 4.73375H6.6755L6.67513 4.73339ZM8.52498 3.43717C8.52498 3.34654 8.59958 3.27262 8.69122 3.27262C8.78286 3.27262 8.85781 3.34655 8.85781 3.43717L8.85917 5.72071H8.52327L8.52498 3.43717ZM9.40625 10.6311H3.27284V9.61619H4.49955C4.57484 9.61619 4.63582 9.55521 4.63582 9.47992V8.44054H5.99885C6.07414 8.44054 6.13512 8.37956 6.13512 8.30427V7.15517H7.49815C7.57344 7.15517 7.63442 7.09419 7.63442 7.0189V5.99277H9.40621L9.40625 10.6311Z",
    fill: "#0B759D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM4Icon);
export default __webpack_public_path__ + "static/media/m4_icon.fcb18d2da5f7ba0c33bd9f4f07d6d8b6.svg";
export { ForwardRef as ReactComponent };